import { Injectable } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { HttpService } from 'src/app/modules/core/services/http.service';
import { catchError, map } from 'rxjs/operators';
import { Dataset, DatasetType, EnumRegistration, EnumRegistrationValue } from 'src/app/modules/core/store/models/dataset.model';
import { Document, EnumerationValue, FieldDataType, QueryResult, SchemaField } from '../../store/models';
import { DatasetsRequest } from '../../store/models/dataset.model';

import { API_BASE_URL as apiBaseUrl } from '@app/core/constants/api-base-url';

@Injectable({ providedIn: 'root' })
export class EnumerationService {
  constructor(private http: HttpService) {}

  getEnumerationRegistrations(): Observable<EnumRegistration[]> {
    const url = `${apiBaseUrl}/v1/meta/datasets/enumeration-registration`;

    return this.http.get(url).pipe(
      catchError(e => {
        console.error(e);
        return of(null);
      }),
      map(res => {
        return res;
      })
    );
  }
}
